export default [{
  path: '/gateway',
  title: 'menu.my_gateway',
  icon: 'wifi_tethering'
}, {
  path: '/activity',
  title: 'menu.my_activity',
  icon: 'receipt'
}, {
  path: '/documents',
  title: 'menu.documents',
  icon: 'developer_board'
}, {
  path: '/settings',
  title: 'menu.settings',
  icon: 'settings'
}];



// WEBPACK FOOTER //
// ./src/helpers/menus.js